import type { IconData } from '@stacksjs/iconify-core'

export const entertainmentEventsHobbiesFilmPlayer: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 3.81v24.38h32V3.81Zm7.61 22.85H1.52V5.33h6.09Zm15.24 0H9.14V5.33h13.71Zm7.62 0h-6.09V5.33h6.09Z\"/><path fill=\"currentColor\" d=\"M25.9 20.57h3.05v3.05H25.9Zm0-6.1h3.05v3.05H25.9Zm0-6.09h3.05v3.05H25.9ZM15.23 19.05h1.53v-1.53h1.52V16h1.52v-1.53h-1.52v-1.52h-1.52v-1.52h-1.53V9.9h-3.04v10.67h3.04zM3.04 20.57h3.05v3.05H3.04Zm0-6.1h3.05v3.05H3.04Zm0-6.09h3.05v3.05H3.04Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default entertainmentEventsHobbiesFilmPlayer
